var map = {
	"./assert": 303,
	"./assert.js": 303,
	"./behavior": 305,
	"./behavior.js": 305,
	"./call": 306,
	"./call.js": 306,
	"./collection": 307,
	"./collection.js": 307,
	"./extend": 308,
	"./extend.js": 308,
	"./format": 309,
	"./format.js": 309,
	"./log_error": 312,
	"./log_error.js": 312,
	"./match": 313,
	"./match.js": 313,
	"./mock": 314,
	"./mock.js": 314,
	"./sandbox": 315,
	"./sandbox.js": 315,
	"./spy": 316,
	"./spy.js": 316,
	"./stub": 317,
	"./stub.js": 317,
	"./test": 318,
	"./test.js": 318,
	"./test_case": 319,
	"./test_case.js": 319,
	"./times_in_words": 320,
	"./times_in_words.js": 320,
	"./typeOf": 321,
	"./typeOf.js": 321,
	"./util/core": 322,
	"./util/core.js": 322,
	"./util/event": 324,
	"./util/event.js": 324,
	"./util/fake_server": 325,
	"./util/fake_server.js": 325,
	"./util/fake_server_with_clock": 326,
	"./util/fake_server_with_clock.js": 326,
	"./util/fake_timers": 327,
	"./util/fake_timers.js": 327,
	"./util/fake_xdomain_request": 329,
	"./util/fake_xdomain_request.js": 329,
	"./util/fake_xml_http_request": 330,
	"./util/fake_xml_http_request.js": 330,
	"./util/timers_ie": 331,
	"./util/timers_ie.js": 331,
	"./util/xdr_ie": 332,
	"./util/xdr_ie.js": 332,
	"./util/xhr_ie": 333,
	"./util/xhr_ie.js": 333,
	"./walk": 334,
	"./walk.js": 334
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 304;



//////////////////
// WEBPACK FOOTER
// ./~/sinon/lib/sinon ^\.\/.*$
// module id = 304
// module chunks = 1